import styled from 'styled-components';

export const NoAccessTitle = styled.h1`
  text-align: center;
  font-size: 22px;
  line-height: 30px;
  font-weight: 500;
  padding: 0 0 20px;
`;
